import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PaginatorModule } from '@com-delta-idp/mnx-skymiles-shared';
import { ImageModule } from '@com-delta-idp/mnx-ui-kit';
import { PushPipe } from '@ngrx/component';
import { BenefitsComponent } from './benefits.component';
import { GoodiesComponent } from './components/goodies/goodies.component';
import { PeakBarComponent } from './components/peak-bar/peak-bar.component';

@NgModule({
  declarations: [BenefitsComponent, GoodiesComponent, PeakBarComponent],
  imports: [CommonModule, PushPipe, ImageModule, PaginatorModule],
  // providers: [DisplayManagerService],
  exports: [BenefitsComponent]
})
export class BenefitsModule {}
